import { NavLink, Outlet, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import NavItem from "react-bootstrap/NavItem";
import { useStockQuery } from 'components/Stock/Stock.hooks';
import { Stock } from 'components/Stock/Stock.helper';

export type StockContextType = {
  symbol: string;
  stock: Stock;
}

export const StockPage = () => {
  const { symbol } = useParams<{ symbol: string }>();
  const stock = useStockQuery(symbol as string);

  return (
    <Container>
      <Row>
        {stock ? (
          <Col>
            <h2>{stock.krShortName}</h2>
          </Col>
        ) : (
          <Col>주식 정보를 불러오는 중입니다...</Col>
        )}
      </Row>
      {stock && (
        <>
          <Row>
            <Col>
              <nav className="nav nav-tabs">
                <NavItem>
                  <NavLink end className="nav-link text-secondary" to={`/stocks/${symbol}`}>정보</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link text-secondary" to={`/stocks/${symbol}/opinions`}>의견</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink end className="nav-link text-secondary" to={`/stocks/${symbol}/news`}>뉴스</NavLink>
                </NavItem>
              </nav>
            </Col>
          </Row>
          <Outlet context={{ symbol, stock }} />
        </>
      )}
    </Container>
  )
}
